type SearchOptions = {
  debounceMs?: number
}

export function createSearch(initialState = "", { debounceMs = 1000 }: SearchOptions = {}) {

  let state = $state(initialState)
  let debouncedState = $state(initialState)
  let timeout: NodeJS.Timeout | undefined

  function set(value: string) {
    state = value
    clearTimeout(timeout)

    if (debounceMs <= 0) {
      debouncedState = value
      timeout = undefined
      return
    }

    timeout = setTimeout(() => {
      debouncedState = state
      timeout = undefined
    }, debounceMs)
  }

  $effect(() => {
    return () => {
      clearTimeout(timeout)
      timeout = undefined
    }
  })

  return {
    get state() {
      return state
    },
    get debounced() {
      return debouncedState
    },
    set,
  }
}